module.exports = __webpack_public_path__ + "static/media/prod12.7fbaeff1.jpg";